import { render, staticRenderFns } from "./PlayerChatUnblock.vue?vue&type=template&id=378a375e&"
import script from "./PlayerChatUnblock.vue?vue&type=script&lang=js&"
export * from "./PlayerChatUnblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports